import { Branding } from 'packages/theming/brands';

export const branding: Branding = {
  siteName: 'Par Perfeito',
  favIconName: 'favicon-par-perfeito',
  name: 'parperfeito',
  facebookUrl: 'https://www.facebook.com/parperfeito',
  instagramUrl: 'https://instagram.com/parperfeito',
  twitterUrl: 'https://www.twitter.com/parperfeito',
  successSiteUrl:
    'http://blog.parperfeito.com.br/historias-de-sucesso/?utm_source=site&utm_medium=footer&utm_campaign=historias_de_sucesso',
  blogUrl: 'http://blog.parperfeito.com.br/?utm_source=site&utm_medium=footer&utm_campaign=home',
};

export default branding;
